module.exports = __webpack_public_path__ + "static/media/hehongshan.81d71654.png";